import axios from 'axios';

const API_BASE = 'https://ibt18xjvyj.execute-api.us-east-1.amazonaws.com';
const USE_MOCK = process.env.REACT_APP_MOCK_CAROUSEL === 'true';

const MOCK_ITEMS = [
  {
    userId: 'mock-1',
    imageUrl: 'https://placehold.co/600x600/eeeeee/333333?text=Mock+1',
    drawingSubject: 'Octopus',
    signature: 'Alex',
    drawingDate: '2026-05-12',
  },
  {
    userId: 'mock-2',
    imageUrl: 'https://placehold.co/600x600/eeeeee/333333?text=Mock+2',
    drawingSubject: 'Bicycle',
    signature: 'Sam',
    drawingDate: '2026-05-13',
  },
  {
    userId: 'mock-3',
    imageUrl: 'https://placehold.co/600x600/eeeeee/333333?text=Mock+3',
    drawingSubject: 'Lighthouse',
    signature: 'Jordan',
    drawingDate: '2026-05-14',
  },
];

export async function fetchCarouselDoodles() {
  if (USE_MOCK) {
    return { items: MOCK_ITEMS };
  }
  const res = await axios.get(`${API_BASE}/getCarouselDoodles`);
  return res.data;
}
